

const rightitems = [{id:'R',text:'čtení'},{id:'W',text:'zápis'}];
const loansources = [{id:1,text:'source1'}];
export {rightitems, loansources}